import { getPreference } from 'FRONTEND/utils/localStorage';

let deserializedState = null;

/**
 * Return the stored state. That state is incomplete because all sensitive data was removed.
 * When using this function, make sure that the desired data is not filtered out by `filterSensitiveData`.
 * @returns Object|null
 */
export const getDeserializedState = () => {
  if (!deserializedState) {
    deserializedState = getPreference(window.userId, 'reduxStore');
  }
  return deserializedState;
};

export const resetDeserializedState = () => {
  deserializedState = null;
};

/**
 * Return a state object without any sensitive data so that it can safely be stored in the localStorage
 * When using `getDeserializedState`, make sure that the desired data is not filtered out.
 * @param state
 */
export const filterSensitiveData = (state) => {
  return {
    app: state.app,
    appointment: state.appointment,
    calendar: {
      actorId: state.calendar.actorId,
      actorType: state.calendar.actorType,
      typeFilterList: state.calendar.typeFilterList,
      eventKindFilterList: state.calendar.eventKindFilterList,
      appointmentStatusFilterList: state.calendar.appointmentStatusFilterList,
      view: state.calendar.view,
    },
    expert: state.expert,
    booking: {
      availableTypeList: state.booking.availableTypeList,
      selectedExpertId: state.booking.selectedExpertId,
      selectedLocationId: state.booking.selectedLocationId,
      selectedPatientId: state.booking.selectedPatientId,
      selectedSlot: state.booking.selectedSlot,
      reason: state.booking.reason,
      desiredDateTime: state.booking.desiredDateTime,
      desiredDuration: state.booking.desiredDuration,
      thirdPartyEmailList: state.booking.thirdPartyEmailList,
      isThirdPartyNotifEnabled: state.booking.isThirdPartyNotifEnabled,
      formType: state.booking.formType,
      selectedType: state.booking.selectedType,
      hasPayment: state.booking.hasPayment,
      desiredConsultationCode: state.booking.desiredConsultationCode,
      isPayLater: state.booking.isPayLater,
    },
    patient: state.patient,
    location: state.location,
    rightPanel: {
      isShown: state.rightPanel.isShown,
    },
    table: {
      tableFilters: state.table.tableFilters,
      tableSearchQuery: state.table.tableSearchQuery,
      tableContext: state.table.tableContext,
    },
  };
};
